module.exports = __webpack_public_path__ + "media/images/font/flaticon-265652da27bf67e99272e90032a58995.ttf";